// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimPayorModel {
    static getAttributeTypeMap() {
        return ClaimPayorModel.attributeTypeMap;
    }
}
ClaimPayorModel.discriminator = undefined;
ClaimPayorModel.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "payorDescription",
        "baseName": "payorDescription",
        "type": "string"
    },
    {
        "name": "participantGroupId",
        "baseName": "participantGroupId",
        "type": "string"
    },
    {
        "name": "participantPlanName",
        "baseName": "participantPlanName",
        "type": "string"
    },
    {
        "name": "participantCoverageEffDate",
        "baseName": "participantCoverageEffDate",
        "type": "Date"
    },
    {
        "name": "participantCoverageTermDate",
        "baseName": "participantCoverageTermDate",
        "type": "Date"
    },
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    }
];
//# sourceMappingURL=claimPayorModel.js.map